import Activity, { ActivityOptions } from 'models/Activity';
import Group, { GroupOptions } from 'models/Group';
import Review, {
  BaseReviewDataOptions,
  getDefaults as getReviewDefaults,
  ReviewOptions,
  ReviewType,
} from 'models/Review';

export type CoordinateRequestData = Partial<
  {
    admissionDate: string;
    createdByEntity: { id: string; name: string; type: string } | null;
  } & BaseReviewDataOptions
>;

export type CoordinateRequestImportedPatient = {
  id: string;
  name: string;
  dateOfBirth: string;
  sex: string;
};

export interface CoordinateRequestOptions extends Omit<ReviewOptions, 'data'> {
  type: ReviewType.COORDINATE_REQUEST;
  data: CoordinateRequestData;
  importedPatient?: CoordinateRequestImportedPatient | null;
  providerGroup?: Partial<GroupOptions> | null;
  activities?: Partial<ActivityOptions>[];
}

export function getDefaults(): CoordinateRequestOptions {
  const defaults = getReviewDefaults();
  return {
    ...defaults,
    type: ReviewType.COORDINATE_REQUEST,
    data: {} as CoordinateRequestData,
    importedPatient: null,
    providerGroup: null,
    activities: [],
  };
}

export default class CoordinateRequest extends Review {
  declare type: ReviewType.COORDINATE_REQUEST;
  data: CoordinateRequestData;
  importedPatient: CoordinateRequestImportedPatient | null;
  providerGroup: Group | null;
  activities: Activity[];

  constructor(options: Partial<CoordinateRequestOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    super(opts);

    this.data = (options.data || {}) as CoordinateRequestData;
    this.importedPatient = options.importedPatient ?? null;
    this.providerGroup = options.providerGroup ? new Group(options.providerGroup) : null;
    this.activities = (options.activities ?? []).map((activity) => new Activity(activity));
  }

  static get type() {
    return ReviewType.COORDINATE_REQUEST;
  }

  get note(): Activity | null {
    return this.activities[0] ?? null;
  }

  get requestedByEntityName() {
    return this.data.createdByEntity?.name ?? '';
  }
}
